export const SET_DISABLE_SAVE_BUTTON = "SET_DISABLE_SAVE_BUTTON";

export interface IActionsSetDisableSaveButton {
  type: "SET_DISABLE_SAVE_BUTTON";
  disable: boolean;
}

export type DocumentEditingActions = IActionsSetDisableSaveButton;
